import { Request } from "../atoms/Utils/Request";
import Urls from "../atoms/urls";

export const NOCService = {
  NOCsearch: ({ tenantId, filters }) =>
    Request({
      url: Urls.noc.nocSearch,
      useCache: false,
      method: "POST",
      auth: true,
      userService: false,
      params: { tenantId, ...filters },
    }),
  NOCupdate: ({ tenantId, filters }) =>
    Request({
      url: Urls.noc.nocUpdate,
      useCache: false,
      method: "POST",
      auth: true,
      userService: false,
      params: { tenantId, ...filters },
    }),
  NOCExcelUpdate: ({ tenantId, nocDetails, filters }) =>
    Request({
      url: Urls.noc.nocExcelUpdate,
      useCache: false,
      method: "POST",
      auth: true,

      data: { nocDetails },
      userService: true,
      params: { tenantId, ...filters },
    }),
  NOCExcelSearch: ({ tenantId, filters }) =>
    Request({
      url: Urls.noc.nocExcelSearch,
      useCache: false,
      method: "POST",
      auth: true,
      userService: false,
      params: { tenantId, ...filters },
    }),
  NOCExcelCreate: ({ tenantId, filters }) =>
    Request({
      url: Urls.noc.nocExcelCreate,
      useCache: false,
      method: "POST",
      auth: true,
      userService: false,
      params: { tenantId, ...filters },
    }),
};
